import {Ability, ConditionType, DamageType} from '../../generated/types';
import {ClassChooseItem} from './class-choose-item';
import {ClassChooseKey} from './class-choose-key';
import {formatClassChoose} from './format-class-choose';

type ClassChooseOr = ClassChooseItem[];

type ClassChoose = ClassChooseOr[];

type ClassChooseProps = {
	darkvision: 60;
	// bonusAction, reaction, attack, extendedAttack
	action: {
		usage: number | 'proficiency';
		recharge: 'longRest' | 'shortRest';
	};
	resists: Array<DamageType | string>; // В качестве строки может быть ключ из choose
	savingThrowConditionAdvantage: Array<ConditionType>;
	savingThrowAdvantage: Array<Ability>;
	hpIncrementEveryLevel: number;
	armorProficiencies: Array<string | 'Heavy' | 'Light' | 'Medium' | 'Shields'>;
	weaponProficiencies: Array<string | 'Simple' | 'Martial' | 'Improvised' | 'LightMartial' | 'FencingMartial'>;
	toolsProficiencies: Array<string>;
	musicalInstrumentProficiencies: Array<string>;
	gamingSetProficiencies: Array<string>;
	savingThrows: Array<Ability>;
	rangedAttackRoll: number;
};

export const formatClassChooseAndProps = (choose: ClassChoose, props: ClassChooseProps) => {
	const result: Record<ClassChooseItem['key'] | string, any> = {};
	if (choose?.at(0)) {
		choose.at(0)!.forEach((item) => {
			result[item.key] = formatClassChoose(item);
		});
	}

	if (props) {
		Object.keys(props).forEach((key) => {
			const prop = props[key as keyof ClassChooseProps];
			// в props бывают и не списки (например, multiclassRequirement для листов персонажей): на странице класса они не выводятся
			if (!Array.isArray(prop)) return;
			result[key] = formatClassChoose({
				key: key as ClassChooseKey,
				options: prop as unknown as string[],
			});
		});
	}

	return result;
};
